var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bet-slip-options",class:{ 'open-options': _vm.open }},[_c('div',{staticClass:"flex head",on:{"click":function($event){_vm.open = !_vm.open}}},[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('bet-slip.multiple-bet-options')))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb96622","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bet-slip/BetSlipOptions.vue
// module id = null
// module chunks = 